/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedFeedResponse } from '../models/PaginatedFeedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FeedService {
    /**
     * Get Global Activity Feed
     * @returns PaginatedFeedResponse A paginated list of feed events
     * @throws ApiError
     */
    public static getActivityFeedFeedGet({
        limit = 20,
        nextToken,
    }: {
        /**
         * Maximum number of events to return
         */
        limit?: number,
        /**
         * Pagination token from previous request
         */
        nextToken?: string,
    }): CancelablePromise<PaginatedFeedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feed',
            query: {
                'limit': limit,
                'nextToken': nextToken,
            },
            errors: {
                400: `Bad Request - Invalid nextToken`,
            },
        });
    }
}
